var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[(_vm.pContIF == 0)?_c('td',{attrs:{"colspan":_vm.pColspan}},[_c('h6',{staticClass:"text-center"},[_vm._v("No contiene registros")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }